export default __webpack_public_path__ + "static/media/gallery_03.a43c13f6.jpg";